module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/pocketwaka/2.png?3611287ea7252968edd757df6f496488";